/**
 * Staff-facing labels for a delivery site.
 *
 * The client's own name for the site is the identifier bakers and drivers
 * recognise; the address always stays visible underneath it.
 */

export const NO_LOCATION_NAME = 'No location name on file';

/** "Corner Bakery — Warehouse" (never replaces the company name). */
export const locationHeading = (order = {}) => {
  const client = order.client_name || '';
  if (order.location_name_source === 'location' && order.location_name) {
    return `${client} — ${order.location_name}`;
  }
  return client;
};

/** The name on its own, for a details row or table cell. */
export const locationLabel = (order = {}) => {
  if (order.location_name_source === 'custom') return order.location_name || '';
  return order.location_name || NO_LOCATION_NAME;
};
